import { atom } from "jotai";

export const userToken = atom<string>("")
export const userId = atom<string>("")
export const selectedQuoteId = atom<string>("")
export const editFunctionLoading = atom(false)
export const reload = atom(false)
